import type { GaApp } from '~/modules/app'

import type { endpoints as endpointsd } from './endpoints'

export class MainRepository {
  gaApp: GaApp
  endpoints

  constructor(gaApp: GaApp, endpoints: typeof endpointsd) {
    this.gaApp = gaApp

    this.endpoints = endpoints
  }

  /**
   * Получение данных пользователя
   */
  async getUser(requestOptions = {}) {
    const { url } = this.endpoints.getUser()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff', ...requestOptions })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Получение приза в рулетке (выпадающий)
   */
  async catchPrize() {
    const { url } = this.endpoints.catchPrize()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff' })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Получение призов для рулетки и страницы призов
   */
  async getPrizes() {
    const { url } = this.endpoints.getPrizes()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff' })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Получение конфигурации игры
   */
  async getGameConfiguration() {
    const { url } = this.endpoints.getGameConfiguration()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff' })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Обновление модального окна ежедневной награды
   */
  async updateDailyModalState() {
    const { url } = this.endpoints.updateDailyModalState()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff' })
        .patch(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Обновление модального окна итогов рейтинга
   */
  async updateRatingResultsModalState() {
    const { url } = this.endpoints.updateRatingResultsModalState()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff' })
        .post(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Текущий рейтинг (лидерборд)
   */
  async getLeaderboardCurrent(requestOptions = {}) {
    const { url } = this.endpoints.getLeaderboardCurrent()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff', ...requestOptions })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Итоги прошлого рейтинга (лидерборд)
   */
  async getLeaderboardPrevious(requestOptions = {}) {
    const { url } = this.endpoints.getLeaderboardPrevious()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff', ...requestOptions })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Позиции пользователя в текущем и прошлом рейтинге
   */
  async getLeaderboardMyPositions(requestOptions = {}) {
    const { url } = this.endpoints.getLeaderboardMyPositions()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff', ...requestOptions })
        .get(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }

  /**
   * Обновление модального промо окна
   */
  async updatePromoModalState() {
    const { url } = this.endpoints.updatePromoModalState()

    try {
      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-assignment, ts/no-unsafe-call
      const response = await this.gaApp.api
        .request({ apiType: 'webBff' })
        .post(url)

      // @ts-expect-error Object is of type 'unknown'
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.api.response(response)
    } catch (error) {
      // @ts-expect-error Object is of type 'unknown'
      throw this.gaApp.api.error(error)
    }
  }
}
